export default "__VITE_ASSET__08285591__"